var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"row-center-fullwidth align-center theme-blue-dark1-color h-80 min-h-80"},[_vm._v("\n  © Peregre Works 2024 | All Rights Reserved\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }